import React from "react";
import { UISref } from "@uirouter/react";
import styled from "styled-components";

const StateName = styled.h2`
    margin-top: 0 !important;
    text-transform: capitalize !important;
    --webkit-column-span: all; /* Chrome, Safari, Opera */
    column-span: all;
`;

const List = styled.ul`
    padding-left: 20px;
`;

const Anchor = styled.a`
    text-decoration: none !important;
    cursor: pointer;
`;

const HeaderAnchor = styled(Anchor)`
    color: #6c6c6c !important;
`;

const LocationAnchor = styled(Anchor)`
    font-weight: 700;
`;

const ListItem = styled.li`
    list-style-type: none;
    overflow: hidden;
`;

const IndexListGroup = ({ state }) => (
    <div>
        <StateName>
            <UISref to="singlePath" params={{ singlePath: state.stateCode }}>
                <HeaderAnchor>{state.stateName}</HeaderAnchor>
            </UISref>
        </StateName>
        <List>
            {state.locations &&
                state.locations.map((location, index) => (
                    <ListItem key={index}>
                        <UISref
                            to="doublePath"
                            params={{
                                firstPath: state.stateCode,
                                secondPath: location.urlKey
                            }}
                        >
                            <LocationAnchor>{location.name}</LocationAnchor>
                        </UISref>
                    </ListItem>
                ))}
        </List>
    </div>
);

export default IndexListGroup;



// WEBPACK FOOTER //
// ./components/index/IndexListGroup.jsx